export const SITE_URL = 'https://www.getgoingpt.com.au';

export const ORGANIZATION_NAME = 'Get Going Personal Training';

// Snapshot from Google Business Profile. Refresh manually on material
// drift, or swap to the Places API when GOOGLE_PLACES_API_KEY is wired.
// Last updated: 2026-04-23
export const AGGREGATE_RATING = {
  ratingValue: '5.0',
  reviewCount: '656',
  bestRating: '5',
} as const;
